var render, staticRenderFns
import script from "./DialogRemote.vue?vue&type=script&lang=js&"
export * from "./DialogRemote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b694e8",
  null
  
)

export default component.exports